document.addEventListener('DOMContentLoaded', function () {
    
    const splideInstances = [];
    const tabButtons = document.querySelectorAll('.tb-heading');
    const tabContents = document.querySelectorAll('.tab-wrapper');

    const initialWrapper = document.querySelector('.tab-wrapper.active');
    if (initialWrapper) {
      const splide = new Splide(initialWrapper.querySelector('.tabslide'), {
        type: 'slide',
        gap: '30px',
        rewind: false,
        arrows: false,
        perPage: 3,
        perMove: 1,
        pagination: true,
        breakpoints: {
          1024: { 
            perPage: 3, 
            gap: '15px',
          },
          768: { 
            perPage: 2,
            gap: '15px',
          },
          480: { 
            perPage: 1
          }
        }
      });
      splide.mount();
      splideInstances[0] = splide;
    }

    tabButtons.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        tabButtons.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        btn.classList.add('active');
        const selectedTab = tabContents[i];
        selectedTab.classList.add('active');

        if (!splideInstances[i]) {
          const splide = new Splide(selectedTab.querySelector('.tabslide'), {
            type: 'slide',
            gap: '30px',
            rewind: false,
            arrows: false,
            perPage: 3,
            perMove: 1,
            pagination: true,
            breakpoints: {
              992: { 
                perPage: 3,
                gap: '15px',
              },
              749: { 
                perPage: 2,
                gap: '15px',
              },
              480: { 
                perPage: 1
              }
            }
          });
          splide.mount();
          splideInstances[i] = splide;
        }
      });
    });


      const tabs = document.querySelectorAll(".faq-tab");

    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        const tabIndex = this.getAttribute("data-tab");
        const content = document.querySelector(`.faq-content[data-tab="${tabIndex}"]`);

        // Check if the clicked content is already active
        const isActive = content.classList.contains("active");

        // Remove active class from all tabs and contents
        document.querySelectorAll(".faq-tab").forEach(t => t.classList.remove("active"));
        document.querySelectorAll(".faq-content").forEach(c => {
          c.classList.remove("active");
          c.style.maxHeight = null;
        });

        // If it was not active before, activate it
        if (!isActive) {
          this.classList.add("active");
          content.classList.add("active");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });


// collection slider 
// var splide = new Splide('#splide-collection', {
//   type       : 'loop',     // Loop through the slides
//   perPage    : 3,          // Number of slides per view
//   autoplay  : true,        // Enable autoplay
//   pagination: true,
//   interval  : 3000,        // Time between slides (in milliseconds)
// });
// splide.mount();  // Mount Splide


// collection slider 
// var splide = new Splide('#splide-collection2', {
//   type       : 'loop',     // Loop through the slides
//   perPage    : 4,          // Number of slides per view
//   autoplay  : true,        // Enable autoplay
//   pagination: true,
//   interval  : 3000,        // Time between slides (in milliseconds)
// });
// splide.mount();  // Mount Splide
  

 const submenus = document.querySelectorAll("header-menu .header__submenu");

  submenus.forEach(function (submenu) {
    const listItems = submenu.querySelectorAll("li");
    if (listItems.length > 5) {
      submenu.classList.add("submenu-column");
    }
  });



  // add alt tag

document.querySelectorAll('img').forEach(img => {
  const alt = img.getAttribute('alt');
  if (alt === null || alt.trim() === '') {
    img.setAttribute('alt', 'enchanted sky');
  }
});

  
  });// End document